import React, { useState } from "react";
import "./navbar.css";

type ViewType = "main" | "compendium" | "achievements" | "settings";

interface NavBarProps {
  showCompendium: CallableFunction;
  currentView: ViewType;
  switchView: (view: ViewType) => void;
}

const NavBar: React.FC<NavBarProps> = ({
  showCompendium,
  currentView,
  switchView,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLinkClick = (view: ViewType) => {
    switchView(view);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="navBar">
      <div className="subNavLeft">
        <a
          className="navItem link"
          target="_blank"
          rel="noreferrer noopener"
          href="https://www.g1bson.dev"
        >
          <div className="navItemText">G1bson</div>
        </a>
        <div className="navItem">
          <div
            className="navItemText"
            onClick={() => handleLinkClick("achievements")}
          >
            Achievements
          </div>
        </div>
      </div>
      {currentView === "main" ? (
        <div className="navTitle noSelect">BrickPacked</div>
      ) : (
        <div
          className="navTitle navTitleClickable"
          onClick={() => handleLinkClick("main")}
        >
          BrickPacked
        </div>
      )}
      <div className="subNavRight">
        <div className="navItem">
          <div
            className="navItemText"
            onClick={() => handleLinkClick("compendium")}
          >
            Compendium
          </div>
        </div>
        <div className="navItem">
          <div
            className="navItemText"
            onClick={() => handleLinkClick("settings")}
          >
            Settings
          </div>
        </div>
      </div>

      {/* Hamburger Menu Button */}
      <div
        className={`hamburger ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Mobile Menu */}
      <div className={`mobileMenu ${isMenuOpen ? "open" : ""}`}>
        <a
          className="mobileMenuItem link"
          target="_blank"
          rel="noreferrer noopener"
          href="https://www.g1bson.dev"
          onClick={() => setIsMenuOpen(false)}
        >
          G1bson
        </a>
        <div
          className="mobileMenuItem"
          onClick={() => handleLinkClick("achievements")}
        >
          Achievements
        </div>
        <div
          className="mobileMenuItem"
          onClick={() => handleLinkClick("compendium")}
        >
          Compendium
        </div>
        <div
          className="mobileMenuItem"
          onClick={() => handleLinkClick("settings")}
        >
          Settings
        </div>
      </div>
    </div>
  );
};

export default NavBar;
